import HexController from 'controllers/hex_controller';

export default class extends HexController {
  static targets = ['submitButton'];

  checkName(e) {
    const nameField = e.target;
    this.submitButtonTarget.disabled = nameField.value.length === 0;
  }
}